var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBkgFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 670,
    viewBox: "0 0 415 670",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 255.758,
    y1: 205.846,
    x2: 334.422,
    y2: 529.422,
    stroke: "url(#paint0_linear_181_17)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 81.0836,
    y1: 287.418,
    x2: 87.9342,
    y2: 315.598,
    stroke: "url(#paint1_linear_181_17)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 168.069,
    y1: 226.135,
    x2: 180.353,
    y2: 276.664,
    stroke: "#31983C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 197.307,
    y1: 36.9607,
    x2: 219.985,
    y2: 130.244,
    stroke: "#31983C",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 143.789,
    y1: 342.155,
    x2: 187.727,
    y2: 522.89,
    stroke: "url(#paint2_linear_181_17)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 48.981,
    y1: 57.5834,
    x2: 92.9197,
    y2: 238.319,
    stroke: "url(#paint3_linear_181_17)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 94.8428,
    y1: 92.1411,
    x2: 113.977,
    y2: 170.849,
    stroke: "#BA61C9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 241.434,
    y1: 394.146,
    x2: 260.568,
    y2: 472.854,
    stroke: "#BA61C9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 129.326,
    y1: 589.148,
    x2: 148.461,
    y2: 667.856,
    stroke: "#BA61C9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 273.954,
    y1: 18.2382,
    x2: 328.759,
    y2: 243.672,
    stroke: "url(#paint4_linear_181_17)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_17",
    x1: 307.092,
    y1: 349.28,
    x2: 155.09,
    y2: 58.4558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFC932",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_17",
    x1: 115.846,
    y1: 349.977,
    x2: 46.3435,
    y2: 258.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BE644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181_17",
    x1: 161.87,
    y1: 433.468,
    x2: 94.4776,
    y2: 279.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_181_17",
    x1: 67.0628,
    y1: 148.896,
    x2: -0.329943,
    y2: -5.55483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_181_17",
    x1: 305.738,
    y1: 81.2429,
    x2: 271.179,
    y2: -1.28387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#528279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B4660"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkgFront);
export default __webpack_public_path__ + "static/media/Bkg-front.b926ae7625d666a4a816b7ee174f1eab.svg";
export { ForwardRef as ReactComponent };